import "./newFinanceMela.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { DriveFolderUploadOutlined as UploadIcon } from "@mui/icons-material";
import {
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { NepaliDatePicker } from "nepali-datepicker-reactjs";
import "nepali-datepicker-reactjs/dist/index.css";
import { useSelector } from "react-redux";

const NewFinanceMela = ({ inputs, title }) => {
  const userIdRedux = useSelector((state) => state.user.userId);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate(); // Initialize navigate

  const { state } = useLocation(); // Access state passed from navigate
  const financeMelaData = state?.financeMela || {}; // Extract financeMela data or use an empty object

  // populate formData with eventData if editing
  const [formData, setFormData] = useState({
    userId: financeMelaData.userId || userIdRedux,
    title: financeMelaData.title || "",
    type: financeMelaData.type || "Income",
    melaName: financeMelaData.melaName || "Maghe Mela",
    amount: financeMelaData.amount || "",
    createdDate: financeMelaData.createdDate || "",
  });

  const [melaNameList, setMelaNameList] = useState([]);
  const [melaName, setMelaName] = useState(financeMelaData.melaName || "");

  const [createdDate, setCreatedDate] = useState(
    financeMelaData.createdDate || "",
  );

  useEffect(() => {
    const fetchMelaList = async () => {
      try {
        const res = await axios.get(
          BASE_URL + `/api/mela/findAllMelaName/${userIdRedux}`,
        );
        setMelaNameList(res.data);
      } catch (error) {
        console.error("Error fetching mela list:", error);
      }
    };

    if (userIdRedux) {
      fetchMelaList();
    }
  }, [userIdRedux]);

  const [errors, setErrors] = useState({});
  const [backEndError, setBackEndError] = useState("");

  const validateForm = () => {
    const errors = {};

    if (!formData.title) errors.title = "Title is required.";
    if (!formData.type) errors.type = "Type is required.";
    if (!formData.melaName) errors.melaName = "Mela Name is required.";
    if (!formData.amount) errors.amount = "Amount is required.";
    if (!createdDate) errors.createdDate = "Created Date is required.";

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    // Prepare the form data for submission (add images if available)
    const formDataToSubmit = new FormData();

    formDataToSubmit.append("userId", formData.userId);
    formDataToSubmit.append("title", formData.title);
    formDataToSubmit.append("type", formData.type);
    // formDataToSubmit.append("melaName", formData.melaName);
    formDataToSubmit.append("melaName", melaName);
    formDataToSubmit.append("amount", formData.amount);
    formDataToSubmit.append("createdDate", createdDate);

    /**
     * choosing URL whether to update or add formDataToSubmit.append("userId", formData.userId);
     *
     */
    const MAIN_URL = financeMelaData._id
      ? `${BASE_URL}/api/financeMela/updateFinanceMela/${financeMelaData._id}`
      : `${BASE_URL}/api/financeMela/addFinanceMela`;

    try {
      let response = "";
      if (financeMelaData._id) {
        response = await axios.put(MAIN_URL, formDataToSubmit, {
          headers: {
            "Content-Type": "application/json",
          },
        });
      } else {
        response = await axios.post(MAIN_URL, formDataToSubmit, {
          headers: {
            "Content-Type": "application/json",
          },
        });
      }

      if (response.status === 201) {
        setBackEndError(<font color="green">Success TO ADD DATA.</font>);
        navigate("/financeMela");
      } else if (response.status === 200) {
        setBackEndError(<font color="green">Success TO UPDATE DATA.</font>);
        navigate("/financeMela");
      } else if (response.status === 401) {
        //alert or show error message
        setBackEndError(<font color="red">USER ALREADY EXISTS.</font>);
      } else if (response.status === 400) {
        //alert or show error message
        setBackEndError(<font color="red">ALL THE FIELDS ARE REQUIRED.</font>);
      } else if (response.status === 402) {
        //alert or show error message
        setBackEndError(<font color="red">INVALID USER DATA.</font>);
      }
    } catch (error) {
      const errorMessage = error.response.data.msg;
      setBackEndError(<span style={{ color: "red" }}>{errorMessage}</span>);
    }
  };

  return (
    <div className="newUser">
      <Sidebar />
      <div className="newUserContainer">
        <Navbar />
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <form
            onSubmit={handleSubmit}
            style={{
              display: "grid",
              gap: "1rem",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", gap: "16px" }}>
              <div style={{ flex: 3 }}>
                <InputLabel style={{ flex: 1 }}>Created Date</InputLabel>
                <FormControl
                  style={{ flex: 2 }}
                  margin="normal"
                  error={Boolean(errors.createdDate)}
                >
                  <NepaliDatePicker
                    inputClassName="form-control"
                    value={createdDate}
                    onChange={(value) => setCreatedDate(value)}
                    options={{ calenderLocale: "ne", valueLocale: "en" }}
                  />
                  {errors.createdDate && (
                    <FormHelperText>{errors.createdDate}</FormHelperText>
                  )}
                </FormControl>
              </div>

              <label style={{ visibility: "hidden", flex: 9 }}></label>
            </div>

            <div style={{ display: "flex", gap: "16px" }}>
              <TextField
                style={{ flex: 6 }}
                name="title"
                label="Title"
                type="text"
                value={formData.title}
                onChange={handleChange}
                error={Boolean(errors.title)}
                helperText={errors.title}
                fullWidth
                margin="normal"
                required
              />
              {/* this label is only for occupy some spaces */}
              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>

            <div style={{ display: "flex", gap: "16px" }}>
              <FormControl
                style={{ flex: 3 }}
                margin="normal"
                error={Boolean(errors.type)}
              >
                <InputLabel>Type</InputLabel>
                <Select
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                >
                  <MenuItem value="Income">Income</MenuItem>
                  <MenuItem value="Expense">Expense</MenuItem>
                </Select>
                {errors.type && <FormHelperText>{errors.type}</FormHelperText>}
              </FormControl>
              <FormControl
                style={{ flex: 3 }}
                margin="normal"
                error={Boolean(errors.melaName)}
              >
                <InputLabel>Mela Name</InputLabel>
                <Select
                  name="melaName"
                  value={melaName}
                  onChange={(e) => setMelaName(e.target.value)}
                  required
                >
                  {melaNameList.map((mela) => (
                    <MenuItem value={mela.melaName}>{mela.melaName}</MenuItem>
                  ))}
                </Select>
                {errors.melaName && (
                  <FormHelperText>{errors.melaName}</FormHelperText>
                )}
              </FormControl>
              {/* this label is only for occupy some spaces */}
              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>
            <div style={{ display: "flex", gap: "16px" }}>
              <TextField
                style={{ flex: 3 }}
                name="amount"
                label="Amount"
                type="number"
                value={formData.amount}
                onChange={handleChange}
                error={Boolean(errors.amount)}
                helperText={errors.amount}
                fullWidth
                margin="normal"
                required
                // disabled={!!financeMelaData._id} // Disables input in update mode
              />
              {/* this label is only for occupy some spaces */}
              <label style={{ visibility: "hidden", flex: 9 }}></label>
            </div>

            <span className="error-message">{backEndError}</span>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{ borderRadius: "15px", width: "50%" }}
            >
              Submit
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewFinanceMela;
